let assetsUrl = String("https://ui.trailhead.com/components/v4.29.3").replace(
  /\/modules.*/,
  ""
);
function getAssetsUrl() {
  return assetsUrl;
}
function setAssetsUrl(url) {
  assetsUrl = url;
}

export { getAssetsUrl, setAssetsUrl };
